// TODO delete this file
import { Span } from "@mallardbay/lib-react-components"

export default Span
